import { featureCollection, point } from '@turf/helpers'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import OLFormatGeoJSON from 'ol/format/GeoJSON'
import { all as OLLoadingStrategyAll } from 'ol/loadingstrategy'
import OLSourceVector from 'ol/source/Vector'

import PoziAPIData from 'api/data'
import { setLayerLoadInProgress } from 'drawer/tabs/layers/actions'

import LoaderHandleGeoJSON, { LoaderFailed } from './LoaderHandleGeoJSON'

export default function (layer) {
  const geojsonSourceOpts = {
    format: new OLFormatGeoJSON(),
    crossOrigin: 'Anonymous',
    loader: function (extent, resolution, projection, success, failure) {
      window.store.dispatch(setLayerLoadInProgress(layer.titleid))
      GetOverpassDataAsGeoJSON(layer)
        .then(function (geojson) {
          LoaderHandleGeoJSON(geojson, projection, geojsonSource, layer, success)
        })
        .catch(function (err) {
          LoaderFailed(layer, err, failure)
        })
    },
    strategy: OLLoadingStrategyAll,
    projection: 'EPSG:3857'
  }

  const geojsonSource = new OLSourceVector(geojsonSourceOpts)

  return geojsonSource
}

// Get geojson from user generated annotations stored as zipped geojson in a cookie.
function GetOverpassDataAsGeoJSON (layer) {
  return new Promise(function (resolve, reject) {
    const url = get(layer, 'config.spatial.url', '')
    let err = ''
    if (isNil(url) || url === '') {
      err = 'GetOverpassDataAsGeoJSON - Invalid URL'
      return reject(err)
    }

    return PoziAPIData().ajaxAsPromise({
      url,
      timeout: 10000
    })
      .then(res => {
        return resolve(ConvertOverpassToGeoJSON(res, resolve, reject))
      })
      .catch(err => {
        console.log('Overpass loader failed to parse data for url', url)
        return reject(err)
      })
  })
}
/**
   * Handle data requests
   * @param json string directly from Overpass API
   * @return FeatureCollection
   */
function ConvertOverpassToGeoJSON (json, resolve, reject) {
  let err = ''
  const features = []
  let fc = featureCollection(features)

  if (isNil(json)) {
    err = 'ConvertOverpassToGeoJSON - Invalid JSON'
    return reject(err)
  }

  const elements = get(json, 'elements', [])
  if (elements.length === 0) {
    console.log('No data found')
    return resolve(fc)
  }

  elements.forEach(function (element) {
    const lat = get(element, 'lat', null)
    const lng = get(element, 'lon', null)
    if (isNil(lat) || isNil(lng)) {
      console.log('Invalid point... no lat/lng found.', element)
      return
    }
    const properties = get(element, 'tags', {})
    const pt = point([lng, lat], properties)
    features.push(pt)
  })

  fc = featureCollection(features)
  return resolve(fc)
}
